import { useAuth } from '@/features/auth/AuthProvider';
import { apiCall } from '@/lib/api';
import { autoPlayWelcomeOnce } from '@/stores/welcome.store';
import { updateMe } from '@uchat-team-management/shared';
import { createEffect } from 'solid-js';

// First entry ever (users.welcomed_at null): play the celebration on whatever
// page the user lands, then persist the mark. Lives at the router root so it
// never unmounts on navigation; the overlay itself is WelcomeCelebration.
export function FirstEntryWelcome() {
  const { session } = useAuth();

  createEffect(() => {
    const s = session();
    if (!s || s.welcomedAt !== null) return;
    // The in-session guard also covers ['auth','me'] refetches that still
    // carry welcomedAt: null while the mark PATCH is in flight.
    if (!autoPlayWelcomeOnce()) return;
    // Fire-and-forget: on failure welcomed_at stays null and the user simply
    // gets one more celebration next login.
    apiCall(updateMe, { body: { welcomed: true } }).catch(() => {});
  });

  return null;
}
